// extracted by mini-css-extract-plugin
export var closed = "_9v-1";
export var resizer = "_9v-0";